import { BalanceResponse } from "../types/BalanceResponse";

class BalanceServices {
    async getBalance(tenant: string, debtNo: string): Promise<BalanceResponse> {
        const response = await fetch("/services/payments/debtBalance/" + tenant + "/" + debtNo, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const returnBalance = await response.json();
        if (returnBalance.amount === null) {
            returnBalance.amount = undefined;
        }
        return returnBalance as BalanceResponse;
    }
}

export default new BalanceServices();
